<template>
  <div class="unitsList">
    <div v-if="!isLoading">
      <mu-card-header titleClass="largeTitle boldTitle" :title="title" :subTitle="subTitle"></mu-card-header>
      <mu-card-text v-if="bindings.height">

        <tab-selector
          :label="$t('message.unitsPreferencesMeasureWeight')"
          v-model="model.weight"
          :list="bindings.weight"
          text-key="unit"
          value-key="preference_id"
        ></tab-selector>

        <tab-selector
          :label="$t('message.unitsPreferencesMeasureHeight')"
          v-model="model.height"
          :list="bindings.height"
          text-key="unit"
          value-key="preference_id"
        ></tab-selector>

        <tab-selector
          :label="$t('message.unitsPreferencesMeasureWaist')"
          v-model="model.waist"
          :list="bindings.waist"
          text-key="unit"
          value-key="preference_id"
        ></tab-selector>

        <tab-selector
          :label="$t('message.unitsPreferencesMeasureHba1c')"
          v-model="model.hba1c"
          :list="bindings.hba1c"
          text-key="unit"
          value-key="preference_id"
        ></tab-selector>

        <tab-selector
          :label="$t('message.unitsPreferencesMeasureBloodGlucose')"
          v-model="model.blood_glucose"
          :list="bindings.blood_glucose"
          text-key="unit"
          value-key="preference_id"
        ></tab-selector>

        <mu-raised-button
          class="large"
          :disabled="isSaving"
          @click.native="submitForm()"
          secondary
          :label="isSaving ? $t('message.updatingText') : $t('message.updateText')"
          fullWidth
        ></mu-raised-button>
      </mu-card-text>
    </div>
    <mu-flexbox v-if="isLoading" justify="center center" align="center center" style="height: 316px;">
      <mu-flexbox-item align="center">
        <mu-circular-progress :size="46"></mu-circular-progress>
        <br/>
        <span v-text="$t('message.loadingText')"></span>
      </mu-flexbox-item>
    </mu-flexbox>
  </div>
</template>
<script>

  import SettingsApi from '../../api/Settings'
  import ListsApi from '../../api/Lists'
  import ScrollerMixin from '../../mixins/ScrollerMixin'
  import UserManager from '../../helpers/UserManager'
  import TabSelector from "../../components/Settings/TabSelector/TabSelector";

  export default {
    components: {TabSelector},
    name: 'settings-units',
    mixins: [ScrollerMixin],
    data() {
      return {
        title: this.$t('message.unitsPreferencesTitle'),
        subTitle: this.$t('message.unitsPreferencesSubTitle'),
        fullWidth: true,
        model: {},
        bindings: {},
        isLoading: true,
        isSaving: false
      }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/settings/units');
      ListsApi.getPreferenceTypes()
        .then(function (response) {
          self.bindings = response.data;
          SettingsApi.getUnitSettings().then(function (response) {
            self.model = response.data;
            self.isLoading = false;
          })
        })
    },
    methods: {
      submitForm() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid) {
              self.isSaving = true;
              SettingsApi.putUnitSettings(self.model)
                .then(function (response) {
                  self.isSaving = false;
                  self.$toastr.success("Updated units");

                  self.$store.commit('setBloodGlucoseCard', {});
                  self.$store.commit('setWeightCard', {});
                  self.$store.commit('setKetonesCard', {});
                  self.$store.commit('setCholesterolCard', {});

                  self.$forceUpdate();
                })
                .catch(function (error) {
                  self.isSaving = false;
                })
            }
          })
          .catch(function () {
            self.isSaving = false;
          })
      }
    }
  }
</script>
<style scoped>
  .mu-card-header > div {
    padding-right: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// Units.vue?34ea0a9e